var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerificationCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 16.25C25 41.6341 28.125 74.6484 61.25 81.25C94.375 74.6484 97.5 41.6341 97.5 16.25H25Z",
    fill: "#DCF4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.25 0L97.5 16.25H25L61.25 0Z",
    fill: "#DCF4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3125 10L17.5 24.5833V46.4583C17.5 66.6927 31.5 85.6146 50.3125 90.2083C69.125 85.6146 83.125 66.6927 83.125 46.4583V24.5833L50.3125 10ZM75.8333 46.4583C75.8333 62.9375 64.9688 78.1406 50.3125 82.6615C35.6562 78.1406 24.7917 62.9375 24.7917 46.4583V29.3229L50.3125 17.9844L75.8333 29.3229V46.4583ZM33.5781 48.6094L28.4375 53.75L43.0208 68.3333L72.1875 39.1667L67.0469 33.9896L43.0208 58.0156L33.5781 48.6094Z",
    fill: "#00955F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationCompleted);
export default __webpack_public_path__ + "static/media/verification-completed.8b8b5cc1df7415b5135d2f0900f4a9f7.svg";
export { ForwardRef as ReactComponent };